import styled from 'styled-components'

export const Title = styled.div`
  margin-bottom: 11px;
  font-size: 17px;
  font-weight: 500;

  color: ${({ theme }) => theme.colors.primary};
`
